import { useEffect, useState } from 'react';
import { useTranslation } from '@/contexts/LanguageContext';
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog';

export function KeyboardShortcutsModal() {
  const [open, setOpen] = useState(false);
  const { t } = useTranslation();

  const shortcuts = [
    { keys: ['⌘', 'D'], descriptionKey: 'ui.keyboardShortcuts.toggleDarkMode' },
    { keys: ['⌘', 'L'], descriptionKey: 'ui.keyboardShortcuts.cycleLanguages' },
    { keys: ['⌘', 'K'], descriptionKey: 'ui.keyboardShortcuts.openSearch' },
    { keys: ['⌘', '?'], descriptionKey: 'ui.keyboardShortcuts.showShortcuts' },
  ];

  useEffect(() => {
    const handleKeyDown = (e: KeyboardEvent) => {
      if ((e.ctrlKey || e.metaKey) && e.key === '?') {
        e.preventDefault();
        setOpen(true);
      }
    };
    window.addEventListener('keydown', handleKeyDown);
    return () => window.removeEventListener('keydown', handleKeyDown);
  }, []);

  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogContent className="sm:max-w-md">
        <DialogHeader>
          <DialogTitle>{t('ui.keyboardShortcuts.title')}</DialogTitle>
        </DialogHeader>
        <div className="space-y-3 py-4">
          {shortcuts.map((shortcut, index) => (
            <div
              key={index}
              className="flex items-center justify-between py-2 border-b border-border last:border-0"
            >
              <span className="text-sm text-muted-foreground">
                {t(shortcut.descriptionKey)}
              </span>
              <div className="flex items-center gap-1">
                {shortcut.keys.map((key, keyIndex) => (
                  <kbd
                    key={keyIndex}
                    className="px-2 py-1 text-xs font-semibold bg-muted rounded border border-border"
                  >
                    {key}
                  </kbd>
                ))}
              </div>
            </div>
          ))}
        </div>
        <p className="text-xs text-muted-foreground text-center">
          {t('ui.keyboardShortcuts.ctrlOrCmd')}
        </p>
      </DialogContent>
    </Dialog>
  );
}
